/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserSourceResponseDto = {
  cognitoUserId: string;
  email?: string;
  name: string;
  surname?: string;
  type: UserSourceResponseDto.type;
};
export namespace UserSourceResponseDto {
  export enum type {
    USER = 'USER',
    CLIENT = 'CLIENT',
    APP = 'APP',
  }
}

